<template>
    <div :class="$style.wrapper">
        <Typography
            type="header"
            size="xs"
            :responsive="false"
        >
            {{ $tr('paymentModal.title') }}
        </Typography>
        <TextInput
            id="gold-amount"
            name="gold-amount"
            type="number"
            :value="amount"
            :class="$style.margin_top"
            @update:modelValue="$emit('update:amount', $event)"
        />
        <Typography
            is="p"
            size="s"
            :responsive="false"
            :class="$style.margin_top"
        >
            {{ $tr('paymentModal.description', { amount: minPurchase.toString() }) }}
        </Typography>
    </div>
</template>
<script setup lang="ts">
import TextInput from '@/components_new/TextInput/TextInput.vue'
import Typography from '@/components_new/Typography.vue'

defineProps<{ amount: number; minPurchase: number }>()
defineEmits<{ (e: 'update:amount', value: number): void }>()
</script>

<style module>
.wrapper {
    padding-top: 20px;
}

.margin_top {
    margin-top: 10px;
}
</style>
